import catalog1 from "../images/catalog1.jpg";
import catalog2 from "../images/catalog2.jpg";
import catalog3 from "../images/catalog3.jpg";
import catalog4 from "../images/catalog4.jpg";
import catalog5 from "../images/catalog5.jpg";
import catalog6 from "../images/catalog6.jpg";
import catalog7 from "../images/catalog7.jpg";
import catalog8 from "../images/catalog8.jpg";
import catalog9 from "../images/catalog9.jpg";
import catalog10 from "../images/catalog10.jpg";
import catalog11 from "../images/catalog11.jpg";

export const catalog = [
    {
        title: "A.1 Clamp Coupling & Accessories",
        products: [
            {
                number: "A50263",
                name: "Clamp Forged 125-S"
            },
            {
                number: "A51531",
                name: "Wedge Pin"
            },
            {
                number: "A51557",
                name: "Wedge Clamp Link"
            },
            {
                number: "A51538",
                name: "Wedge Clamp Rivet"
            },
            {
                number: "A50073",
                name: "Clamp Coupling ZX K 5 5"
            },
            {
                number: "A50076",
                name: "Clamp Coupling ZX-W 6 HD"
            },
            {
                number: "A50261",
                name: 'Clamp Coupling SK 5.5" / 125'
            },
        ],
        image: catalog1
    },
    {
        title: "A.2 Filters",
        products: [
            {
                number: "A50084",
                name: "High Pressure Filter Element 10μ"
            },
            {
                number: "A50186",
                name: "High Pressure Filter Element 10μ"
            },
            {
                number: "A50003",
                name: "Filter Element 175μ"
            },
            {
                number: "A51555",
                name: "Suction Filter 10μ"
            },
            {
                number: "A51556",
                name: "Spin on return line filter"
            },
            {
                number: "A50159",
                name: "Filter Element for Return Suction Filter"
            },
            {
                number: "A50160",
                name: 'Filter Element for Suction Filter 10μ'
            },
            {
                number: "A50083",
                name: 'Filter Element for Suction Filter 10μ'
            }
        ],
        image: catalog2
    },
    {
        title: "A.3 Wear Parts",
        products: [
            {
                number: "A50238",
                name: "Spectacle Plate Φ230 Carbide"
            },
            {
                number: "A50237",
                name: "Wear Ring Carbide 230"
            },
            {
                number: "A50236",
                name: "Thrust Ring Φ 230"
            },
            {
                number: "A50447",
                name: 'Intermediate Ring 230'
            },
            {
                number: "A50033",
                name: "Spectacle Plate Carbide 20"
            },
            {
                number: "A50031",
                name: "Wear Ring Carbide200"
            },
            {
                number: 'A50032',
                name: 'Thrust Ring 200'
            },
            {
                number: 'A50005',
                name: 'Intermediate Ring 200'
            },
            {
                number: 'A51265',
                name: 'Expander Ring Φ180 cylinder'
            },
            {
                number: 'A50006',
                name: 'O-ring 235x5'
            },
            {
                number: 'A50009',
                name: 'O-ring 220x5'
            },
            {
                number: 'A50007',
                name: 'O-ring 210x8'
            },
            {
                number: 'A50008',
                name: 'O-ring 200x5'
            }
        ],
        image: catalog3
    },
    {
        title: "A.4 Grease System",
        products: [
            {
                number: "A50581",
                name: "GREASE DISTR. 12-f.SSVD12/11 V2"
            },
            {
                number: "A50842",
                name: "GREASE HOSE SET HOPPER"
            },
            {
                number: "A50943",
                name: "GREASE DISTR. 7X M10X1"
            },
            {
                number: "A50852",
                name: "Central Lube Pump Manual"
            },
            {
                number: "A50862",
                name: "LUB DISTRIBUTOR SSV6-K"
            },
            {
                number: "A50863",
                name: "LUBRICANT DISTR. 8-SSV 8"
            },
            {
                number: "A51041",
                name: "Central Lube Pump - Electric"
            }
        ],
        image: catalog4
    },
    {
        title: "A.5 Agitator Motors",
        products: [
            {
                number: "A50148",
                name: "Hydraulic Motor 750 CC"
            },
            {
                number: "A50117",
                name: "Hydraulic Motor 500 CC"
            },
            {
                number: 'A50342',
                name: 'Mixer Shaft D60x185'
            },
            {
                number: 'A50398',
                name: 'Mixer Shaft D45x255'
            },
            {
                number: 'A50154',
                name: 'Mixer Shaft Central Part'
            },
            {
                number: 'A50056',
                name: 'Mixing paddle, left'
            },
            {
                number: 'A50057',
                name: 'Mixing paddle, right'
            },
            {
                number: 'A50485',
                name: 'Bearing Flange Blind'
            },
            {
                number: 'A50216',
                name: 'Support Flange Open'
            }
        ],
        image: catalog5
    },
    {
        title: "A.6 Delivery Pipeline",
        products: [
            {
                number: "A51444",
                name: "Delivery Pipe-Wedge-125-S-3m"
            },
            {
                number: "A51445",
                name: "Delivery Pipe-Wedge-125-S-2m"
            },
            {
                number: "A51446",
                name: "Delivery Pipe-Wedge-125-S-1m"
            },
            {
                number: "A51447",
                name: "Delivery Pipe-Wedge-125-S-0.5m"
            },
            {
                number: "A51448",
                name: "Wedge Type 90° Long Rad_125"
            },
            {
                number: "A51450",
                name: "Wedge Type 90° Medium Rad_125"
            },
            {
                number: "A51449",
                name: "Wedge Type 90° Short Rad_125"
            },
            {
                number: "A51451",
                name: "Wedge Type 60° Bend_125"
            },
            {
                number: "A51452",
                name: "Wedge Type 45° Bend_125"
            },
            {
                number: "A51453",
                name: "Wedge Type 30° Bend_125"
            },
            {
                number: "A51455",
                name: "Wedge Type 15° Bend_125"
            },
            {
                number: "A51442",
                name: "Wedge Type S-Bend"
            },
            {
                number: "A50262",
                name: "Sealing Ring DN-125-S"
            },
            {
                number: "A50278",
                name: "Sponge Ball Hard 150 dia"
            },
            {
                number: "A50546",
                name: "End Hose Wedge Type 125 5.5 X 3000"
            },
            {
                number: "A51343",
                name: "End Hose Wedge Type 125, 5.5 X 4000mm"
            }
        ],
        image: catalog6
    },
    {
        title: "A.7 Plunger Cylinder Parts",
        products: [
            {
                number: "A50208",
                name: "Upper Housing Assembly 90mm"
            },
            {
                number: 'A50241',
                name: 'Swing Lever 90mm'
            },
            {
                number: 'A50210',
                name: 'Wear Sleeve 90mm'
            },
            {
                number: 'A50240',
                name: 'Comp Upper Housing Taper 90mm'
            },
            {
                number: 'A50243',
                name: 'Wear Sleeve D100x90x117'
            },
            {
                number: 'A50244',
                name: 'Support Flange for 90mm Taper'
            },
            {
                number: 'A50242',
                name: 'Ball cup 60/70x38'
            },
            {
                number: 'A50035',
                name: 'Comp Upper Housing BSA 80mm'
            },
            {
                number: 'A50036',
                name: 'Swing Lever BSA 80mm'
            },
            {
                number: 'A50039',
                name: 'Wear Sleeve 80mm'
            },
            {
                number: 'A50040',
                name: 'Support Flange 80mm'
            },
            {
                number: 'A50144',
                name: 'Plunger Cylinder 160-60 (Single Port)'
            },
            {
                number: 'A51419',
                name: 'Seal set for P Cylinder Single Port'
            },
            {
                number: 'A50113',
                name: 'Plunger Cylinder 160-60 (Double Port)'
            },
            {
                number: 'A50413',
                name: 'Seal set for P Cylinder Double Port'
            }
        ],
        image: catalog7
    },
    {
        title: "A.8 Discharge Support Assembly Parts",
        products: [
            {
                number: "A50030",
                name: "Wear Sleeve D220x210x115"
            },
            {
                number: 'A50048',
                name: 'Outer Housing 220/270 New'
            },
            {
                number: 'A50049',
                name: 'WiperRing 220x240x8'
            },
            {
                number: 'A50050',
                name: 'Lip Seal Ring 220x235x14.6 TM23'
            },
            {
                number: 'A50252',
                name: 'Guiding Band D220x225x20'
            },
            {
                number: 'A50053',
                name: 'Lip Seal Ring 220x240x15KI1320'
            },
            {
                number: 'A50054',
                name: 'Plain Compression Ring 232x185x20'
            },
            {
                number: 'A51355',
                name: 'Discharge Support Housing D220/270'
            },
            {
                number: 'A50052',
                name: 'Guide Band, 220X 225X 24,5'
            },
            {
                number: 'A50007',
                name: 'O-ring 210x8'
            },
            {
                number: 'A50335',
                name: 'Plain Compression Ring 230x20x20'
            },
            {
                number: 'A51420',
                name: 'Seal set for Discharge Support Old'
            },
            {
                number: 'A51421',
                name: 'Seal set for Discharge Support New'
            }
        ],
        image: catalog8
    },
    {
        title: "A.9 Boom Pump Pipeline & Bends",
        products: [
            {
                number: "A50255",
                name: "Elbow Cast Mn SK125-5.5-16 90° 275S"
            },
            {
                number: 'A50744',
                name: 'Elbow Cast Mn SK 125/5,5 90° 180S'
            },
            {
                number: 'A50407',
                name: 'Twin Layer Elbow SK 125-5.5-72 90° 275S'
            },
            {
                number: 'A50256',
                name: 'Elbow Cast Mn SK125-5.5-16 45° 120/120'
            },
            {
                number: 'A50619',
                name: 'Elbow Cast Mn SK125-5.5-16 45°'
            },
            {
                number: 'A50258',
                name: 'Elbow Cast Mn ZXM/ZXV 150-6.0-74 90°'
            },
            {
                number: 'A50257',
                name: 'Reducer ZXV150-6.0/SK125-5.5 1200mm Harden'
            },
            {
                number: 'A50300',
                name: 'Seamless ST 52 Del. Pipe SK 125-5.5"X3000mm - L'
            }
        ],
        image: catalog9
    },
    {
        title: "A.10 Delivery Piston Assembly Parts",
        products: [
            {
                number: "A50291",
                name: "Delivery Piston 230"
            },
            {
                number: 'A50021',
                name: 'Delivery Piston 200'
            },
            {
                number: 'A51386',
                name: 'Delivery Piston 180'
            },
            {
                number: 'A50022',
                name: 'Delivery Piston Seal,D200'
            },
            {
                number: 'A50025',
                name: 'Guide Ring 200.0x180.0x40.0'
            },
            {
                number: 'A50422',
                name: 'Delivery Piston Seal 180'
            },
            {
                number: 'A50449',
                name: 'Guide Ring 180'
            },
            {
                number: 'A50641',
                name: 'Connection Piece'
            },
            {
                number: 'A50023',
                name: 'Piston Bench'
            },
            {
                number: 'A50024',
                name: 'Flange'
            },
            {
                number: 'A50026',
                name: 'Hexagon head cap screw M20x180'
            },
            {
                number: 'A50027',
                name: 'Hex nut, Self-lock M20'
            },
            {
                number: 'A50028',
                name: 'Spacer Flange'
            },
            {
                number: 'A50694',
                name: 'Piston Rod Flange'
            }
        ],
        image: catalog10
    },
    {
        title: "A.11 Hy. Cylinder and Assembly Parts",
        products: [
            {
                number: "A50110",
                name: "Hydraulic Cylinder 1400-110/63"
            },
            {
                number: 'A50107',
                name: 'Hydraulic Cylinder 1000-110/63'
            },
            {
                number: 'A50109',
                name: 'Piston rod 1400-63'
            },
            {
                number: 'A50112',
                name: 'Piston rod 1400-63'
            },
            {
                number: 'A51303',
                name: 'Head Flange'
            },
            {
                number: 'A51304',
                name: 'Guide Bush'
            },
            {
                number: 'A50010',
                name: 'Guide Ring 63x24'
            },
            {
                number: 'A50011',
                name: 'Seal set for Rod'
            },
            {
                number: 'A50233',
                name: 'O-ring 102x4'
            },
            {
                number: 'A50012',
                name: 'Back Up Ring'
            },
            {
                number: 'A50013',
                name: 'Scraper Ring'
            },
            {
                number: 'A51656',
                name: 'Piston Ring Set'
            }
        ],
        image: catalog11    
    }
]